import { render } from "./SaveMenu.vue?vue&type=template&id=69e7fc4c&scoped=true&ts=true"
import script from "./SaveMenu.vue?vue&type=script&lang=ts"
export * from "./SaveMenu.vue?vue&type=script&lang=ts"

import "./SaveMenu.vue?vue&type=style&index=0&id=69e7fc4c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e7fc4c"]])

export default __exports__